import { useEffect, useState } from "react";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "arcadeops_cookie_consent_v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) setVisible(true);
    } catch {
      setVisible(true);
    }
    const onReopen = () => {
      try { localStorage.removeItem(STORAGE_KEY); } catch { /* ignore */ }
      setVisible(true);
    };
    window.addEventListener("arcadeops:cookies:reopen", onReopen);
    return () => window.removeEventListener("arcadeops:cookies:reopen", onReopen);
  }, []);

  const persist = (choice) => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ choice, at: new Date().toISOString() })
      );
    } catch { /* ignore */ }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      role="dialog"
      aria-label="Cookie consent"
      className="fixed bottom-2 left-2 right-2 sm:left-auto sm:right-3 sm:bottom-3 sm:max-w-sm z-[60] border border-border bg-black/90 backdrop-blur-md shadow-xl"
    >
      <div className="px-3 py-2 flex items-center gap-2.5">
        <Cookie className="w-3.5 h-3.5 text-neon-yellow shrink-0" />
        <p className="flex-1 text-[11px] leading-snug text-muted-foreground">
          Essential cookies run the site; optional analytics help us improve it.{" "}
          <a href="/privacy" className="text-neon-cyan hover:underline">Privacy</a>
        </p>
        <button data-testid="cookie-accept-all" onClick={() => persist("all")} className="h-7 px-2.5 bg-neon-yellow text-black font-mono text-[10px] uppercase tracking-widest font-bold hover:bg-[#e8b230] transition-colors">Accept</button>
        <button data-testid="cookie-essential-only" onClick={() => persist("essential")} className="h-7 px-2 border border-border text-muted-foreground font-mono text-[10px] uppercase tracking-widest hover:text-foreground hover:border-foreground transition-colors">Essential</button>
        <button data-testid="cookie-dismiss" onClick={() => persist("dismissed")} className="h-7 w-7 flex items-center justify-center text-muted-foreground hover:text-foreground" aria-label="Dismiss"><X className="w-3.5 h-3.5" /></button>
      </div>
    </div>
  );
}
